module.exports = __webpack_public_path__ + "static/media/21.0ab7ad4b.png";